import {BASE_TRACK_API_URL} from "@constants/config";
import {OnShowError} from "@baseTypes/base";
import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";
import {
    IPlannedResourcesSingleVoyage,
    IPropsGetPlannedResourcesSingleVoyage
} from "@containers/singleVoyage/containers/plannedResources/types";
import {serialize} from "@helpers/query/serialize";

const BASE_URL = `${BASE_TRACK_API_URL}/v1/accounts`

export const getSingleVoyagePlannedResourceApi = async (
    {accountId, plannedStart, plannedEnd}: IPropsGetPlannedResourcesSingleVoyage,
    onError?: OnShowError,
): Promise<IPlannedResourcesSingleVoyage> => {

    // The endpoint reads planningStart/planningEnd; sent under any other name they arrive null and
    // the backend skips the busy-device filter entirely, returning every vehicle as free.
    const url = `${BASE_URL}/${accountId}/single-voyages/resource?` + serialize({
        planningStart: plannedStart,
        planningEnd: plannedEnd,
    });
    return await apiRequestWithAuth<IPlannedResourcesSingleVoyage>({
        url,
        options: {
            method: "GET",
        },
        onError
    });
}